import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function MusicChartHeader({ sortConfig, requestSort, showDetailedSpins = false, showFirstOn = false }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={3} xl onClick={requestSort ? () => requestSort("artist") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl onClick={requestSort ? () => requestSort("title") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col
                    xs={showDetailedSpins ? 3 : 2}
                    xl={showDetailedSpins ? 1 : 2}
                    onClick={requestSort ? () => requestSort("release_year") : null}
                    className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col
                    xs={showDetailedSpins ? 3 : 2}
                    xl={showDetailedSpins ? 1 : 2}
                    onClick={requestSort ? () => requestSort("first_play") : null}
                    className={`align-self-center order-${showDetailedSpins ? 0 : 2} order-xl-last`}>
                    <Stack direction="horizontal" className="justify-content-center text-center">
                        <span className="offset-1 text-center">First Played</span>
                        <span className="col-1">{renderSortIcon("first_play", sortConfig)}</span>
                    </Stack>
                </Col>
                {showFirstOn && (
                    <Col
                        xs={2}
                        xl={2}
                        onClick={requestSort ? () => requestSort("first_on") : null}
                        className=" align-self-center d-none d-xl-block order-xl-last">
                        <Stack direction="horizontal" className="justify-content-center text-center">
                            <span className="offset-1 text-center">First on</span>
                            <span className="col-1">{renderSortIcon("first_on", sortConfig)}</span>
                        </Stack>
                    </Col>
                )}
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("spins") : null} className=" align-self-center order-1">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1">Spins</span>
                        <span className="col-1">{renderSortIcon("spins", sortConfig)}</span>
                    </Stack>
                </Col>
                {showDetailedSpins && (
                    <Col xs xl={4} className=" order-2">
                        <Row className=" border-bottom d-none d-xl-block">
                            <Col className=" text-center ">Daypart Spins</Col>
                        </Row>
                        <Row>
                            <Col xs={3} onClick={requestSort ? () => requestSort("spins_18_6") : null} className=" align-self-center">
                                <Stack direction="horizontal" className="justify-content-center text-center">
                                    <span className="offset-1 text-center">18-06</span>
                                    <span className="col-1">{renderSortIcon("spins_18_6", sortConfig)}</span>
                                </Stack>
                            </Col>
                            <Col xs={3} onClick={requestSort ? () => requestSort("spins_6_10") : null} className=" align-self-center">
                                <Stack direction="horizontal" className="justify-content-center text-center">
                                    <span className="offset-1 text-center">06-10</span>
                                    <span className="col-1">{renderSortIcon("spins_6_10", sortConfig)}</span>
                                </Stack>
                            </Col>
                            <Col xs={3} onClick={requestSort ? () => requestSort("spins_10_14") : null} className=" align-self-center">
                                <Stack direction="horizontal" className="justify-content-center text-center">
                                    <span className="offset-1 text-center">10-14</span>
                                    <span className="col-1">{renderSortIcon("spins_10_14", sortConfig)}</span>
                                </Stack>
                            </Col>
                            <Col xs={3} onClick={requestSort ? () => requestSort("spins_14_18") : null} className=" align-self-center">
                                <Stack direction="horizontal" className="justify-content-center text-center">
                                    <span className="offset-1 text-center">14-18</span>
                                    <span className="col-1">{renderSortIcon("spins_14_18", sortConfig)}</span>
                                </Stack>
                            </Col>
                        </Row>
                    </Col>
                )}
            </Row>
        </Container>
    );
}
